import { useAuth } from '@frontegg/react';
import { useQuery } from '@tanstack/react-query';
import { ENVIRONMENTS } from '@elementary/common-ui/constants/queryKeys';
import * as api from '../services/settingsApi';

const useEnvironmentsPolling = () => {
  const { isAuthenticated } = useAuth();

  useQuery([ENVIRONMENTS], () => api.fetchEnvironments(), {
    enabled: isAuthenticated,
    refetchInterval: 30000,
    keepPreviousData: true,
  });
};

export default useEnvironmentsPolling;
